export default [
  {
    path: '/base-manage',
    redirect: {name: 'area-manage-index'}
  }
]
